import {
  CodeIcon,
  Database01Icon,
  File01Icon,
  GitForkIcon,
  Message01Icon,
  SentIcon,
  Settings01Icon,
  type TerraIcon,
} from '@terra/ui-icons';
import { token } from '@terra/ui-styled-system';
import type { CompositionVisualKind } from './compositionGraphModel';

export type CompositionVisualStyle = {
  icon: TerraIcon;
  bg: string;
  fg: string;
  bd: string;
};

export const COMPOSITION_VISUAL_STYLE: Record<
  CompositionVisualKind,
  CompositionVisualStyle
> = {
  AGENT: {
    icon: Message01Icon,
    bg: token('colors.orange.3'),
    fg: token('colors.terra.10'),
    bd: token('colors.orange.6'),
  },
  ROUTER: {
    icon: GitForkIcon,
    bg: token('colors.purple.3'),
    fg: token('colors.purple.11'),
    bd: token('colors.purple.6'),
  },
  MIDDLEWARE: {
    icon: File01Icon,
    bg: token('colors.yellow.3'),
    fg: token('colors.yellow.11'),
    bd: token('colors.neutral.5'),
  },
  MEMORY: {
    icon: Database01Icon,
    bg: token('colors.sky.3'),
    fg: token('colors.sky.11'),
    bd: token('colors.sky.6'),
  },
  TOOL_FUNCTION: {
    icon: CodeIcon,
    bg: token('colors.green.3'),
    fg: token('colors.green.11'),
    bd: token('colors.green.6'),
  },
  TOOL_HOSTED: {
    icon: SentIcon,
    bg: token('colors.green.3'),
    fg: token('colors.green.11'),
    bd: token('colors.green.6'),
  },
  TOOL: {
    icon: Settings01Icon,
    bg: token('colors.neutral.3'),
    fg: token('colors.neutral.11'),
    bd: token('colors.neutral.6'),
  },
};

export const COMPOSITION_SHOWN_DOT = token('colors.green.9');
export const COMPOSITION_HIDDEN_DOT = token('colors.neutral.9');
export const COMPOSITION_SELECTED_BORDER = token('colors.terra.9');
export const COMPOSITION_VERIFIED_BORDER = token('colors.green.6');
export const COMPOSITION_CARD_BORDER = token('colors.neutral.5');
export const COMPOSITION_EDGE_HOT = token('colors.terra.9');
export const COMPOSITION_EDGE_COLD = token('colors.neutral.7');
export const COMPOSITION_LABEL_HOT_BORDER = token('colors.orange.6');
export const COMPOSITION_LABEL_COLD_BORDER = token('colors.neutral.5');
export const COMPOSITION_LABEL_HOT_COLOR = token('colors.terra.10');
export const COMPOSITION_LABEL_COLD_COLOR = token('colors.neutral.11');
export const COMPOSITION_SELECTED_SHADOW = `0 0 0 3px ${token('colors.terra.a5')}, 0 6px 18px ${token('colors.terra.a3')}`;
export const COMPOSITION_CANVAS_DOT = token('colors.neutral.5');
